import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";

export const drivingPovDetectExample: TemplateDefinition = {
  mode: "detect",
  slug: "driving-pov-detect-example",
  version: 1,
  title: "Autonomous driving",
  description: "Read the road ahead",
  subdescription: "Spot crosswalks, yield signs, cars, and hands from behind the wheel.",
  thumbnailUuid: BASE_ASSETS.drivingPovExample.uuid,
  assets: [BASE_ASSETS.drivingPovExample],
  detect: {
    mediaUuid: BASE_ASSETS.drivingPovExample.uuid,
    categories: ["crosswalk", "yield signs", "cars", "hands"],
    config: {
      output: "box",
    },
  },
};
